import request from '@/utils/request'

//  编辑商品与门店-分组关系
export const setStoreGoodsGroup = (updateData) => {
    return request.put('/goodsStoreGroup/store', updateData)
}

//  编辑商品与网店-分组关系
export const setOnlineStoreGoodsGroup = (updateData) => {
    return request.put('/goodsStoreGroup/onlineStore', updateData)
}